import React, { useState, useEffect } from "react";

const ResendCode = ({ onResend, email }) => {
  const [secondsLeft, setSecondsLeft] = useState(30);
  const [isResending, setIsResending] = useState(false);

  useEffect(() => {
    if (secondsLeft > 0) {
      const timer = setTimeout(() => setSecondsLeft(secondsLeft - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [secondsLeft]);

  const handleResend = async () => {
    setIsResending(true);
    try {
      await onResend(email); // Trigger resend logic (API call or local handler)
      setSecondsLeft(30); // Restart timer
    } catch (error) {
      console.error("Resend failed:", error);
    } finally {
      setIsResending(false);
    }
  };

  return (
    <div style={{ marginTop: "1rem" }}>
      {secondsLeft > 0 ? (
        <p style={{ fontSize: "14px", color: "#555" }}>
          Didn't receive your code? You can resend it in{" "}
          <strong>{secondsLeft}s</strong>.
        </p>
      ) : (
        <button
          onClick={handleResend}
          disabled={isResending}
          style={{
            padding: "8px 16px",
            backgroundColor: "#007bff",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: isResending ? "not-allowed" : "pointer",
          }}
        >
          {isResending ? "Sending..." : "Resend Code"}
        </button>
      )}
    </div>
  );
};

export default ResendCode;
